import { ToastNotification, VStack } from '@/components/sgBootstrapReactWrapper';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { removeToast, selectToasts } from '@/store/toasts/globalToastsSlice';

export const GlobalToasts = () => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector(selectToasts);

  return (
    <VStack
      className={'position-fixed pe-none p-8px'}
      style={{ bottom: 0, top: 0, left: 0, right: 0, zIndex: 2 }}
      verticalAlignment="start"
      horizontalAlignment="end"
      gap="16px"
    >
      {toasts.map(({ id, header, content }) => (
        <ToastNotification
          key={id}
          onClose={() => dispatch(removeToast(id))}
          color="info"
          header={header}
          content={content}
        />
      ))}
    </VStack>
  );
};
